function toggleReplyRow($row: JQuery): void {
  const parentId = $row.attr("id");
  const $reply = parentId
    ? $row.siblings(`.reply-row[data-parent="${parentId}"]`)
    : $row.next(".reply-row");
  if (!$reply.length) return;
  const open = !$reply.hasClass("open");
  // .open on the main row rotates the caret (tr.ctr.open .exp-caret) and reveals the panel row
  $reply.toggleClass("open", open);
  $row.toggleClass("open", open);
  $row.find(".exp-caret").attr("aria-expanded", open ? "true" : "false");
}

export function initContactedReply(): void {
  $(document)
    .off("click.contactedReply")
    .on("click.contactedReply", ".camp-refresh.cand-table .exp-caret", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleReplyRow($(this).closest("tr.ctr"));
    });

  $(document)
    .off("click.contactedRow")
    .on("click.contactedRow", ".camp-refresh.cand-table tr.ctr", function (e) {
      if ($(e.target).closest("a, button, input, label, select, textarea, .cbtn, .switch, .respick, .row-act, .view-full-data, .dd, [data-candidate-open]").length) return;
      toggleReplyRow($(this));
    });
}

export function initContacted() {
  const $tabs = $('.contacted-filter-tabs#filter');
  if (!$tabs.length) return;

  const tabs = $tabs[0];
  const $wrapper = $tabs.closest('.contacted-filter-tabs-wrapper');
  const $hintLeft = $wrapper.find('.filter-tabs-scroll-hint.left');
  const $hintRight = $wrapper.find('.filter-tabs-scroll-hint.right');

  function updateScrollHints(): void {
    const maxScroll = tabs.scrollWidth - tabs.clientWidth;
    $hintLeft.toggleClass('d-none', tabs.scrollLeft <= 1);
    $hintRight.toggleClass('d-none', tabs.scrollLeft >= maxScroll - 1);
  }

  $tabs.off('scroll.filterTabsHint').on('scroll.filterTabsHint', updateScrollHints);
  $(window).off('resize.filterTabsHint').on('resize.filterTabsHint', updateScrollHints);

  $wrapper.find('.filter-tabs-scroll-hint').off('click.filterTabsHint').on('click.filterTabsHint', function() {
    const direction = $(this).hasClass('left') ? -1 : 1;
    tabs.scrollBy({ left: direction * Math.round(tabs.clientWidth * 0.6), behavior: 'smooth' });
  });

  updateScrollHints();
}